import React, { useContext, useEffect, useState } from "react";

import DrawerActions from "shared/components/data-display/drawers/DrawerActions";
import DrawerContext from "shared/contexts/DrawerContext";
import DropdownMultiSelect, { getDropdownMultiSelectOptions } from "shared/components/inputs/dropdown-multi-select/DropdownMultiSelect";
import PropTypes from "prop-types";
import Subject from "shared/components/data-display/drawers/Subject";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import VStack from "shared/components/layout/stack/VStack";
import { useClientsFilterApi } from "features/admin/projects/single/useProjectsLinked";

export const clientStatusOptions = [
    {
        id: 1,
        value: "",
        label: "All",
        check: false,
        indeterminate: false,
        children: [
            {
                parentId: 1,
                id: 2,
                check: false,
                label: "Active",
                value: true,
            },
            {
                parentId: 1,
                id: 3,
                check: false,
                label: "Inactive",
                value: false,
            },
        ],
    },
];

export const apiStatusOptions = [
    {
        id: 1,
        value: "",
        label: "All Status Values",
        check: false,
        indeterminate: false,
        children: [
            {
                parentId: 1,
                id: 2,
                check: false,
                label: "Undefined",
                value: 0,
            },
            {
                parentId: 1,
                id: 3,
                check: false,
                label: "To be extracted",
                value: 1,
            },
            {
                parentId: 1,
                id: 4,
                check: false,
                label: "Extracted",
                value: 2,
            },
            {
                parentId: 1,
                id: 5,
                check: false,
                label: "Success",
                value: 3,
            },
            {
                parentId: 1,
                id: 6,
                check: false,
                label: "Error",
                value: 4,
            },
        ],
    },
];

export const filterDropdownNames = {
    client: "ClientName",
    clientStatus: "ClientStatus",
    API: "SAP_API_Status_Id",
};

const FilterDrawer = ({ setFiltersData, initialData }) => {
    const { clientsFilter } = useClientsFilterApi();

    const { setShow } = useContext(DrawerContext);

    const [filtersAll, setFiltersAll] = useState([]);
    const [isClearAllSelectedData, setIsClearAllSelectedData] = useState(false);

    const [clientDropdownOptions, setclientDropdownOptions] = useState([]);

    const [clientInitialData, setClientInitialData] = useState([]);
    const [clientStatusInitialData, setClientStatusInitialData] = useState([]);
    const [APIInitialData, setAPIInitialData] = useState([]);

    useEffect(() => {
        !clientsFilter.isLoading &&
            clientDropdownOptions?.length === 0 &&
            setclientDropdownOptions(
                getDropdownMultiSelectOptions(
                    clientsFilter?.data,
                    "ClientId",
                    "Name",
                    "ClientId"
                )
            );
    }, [clientsFilter, clientDropdownOptions?.length]);

    useEffect(() => {
        if (
            clientDropdownOptions.length > 0 &&
            clientInitialData.length === 0
        ) {
            initialData?.forEach((filterData) => {
                if (filterData?.id === filterDropdownNames.client) {
                    setClientInitialData(
                        filterData?.value?.map((clientData) => {
                            return clientData;
                        })
                    );
                }
            });
        }
    }, [clientDropdownOptions, clientInitialData.length, initialData]);

    useEffect(() => {
        initialData?.forEach((filterData) => {
            if (filterData?.id === filterDropdownNames.clientStatus) {
                setClientStatusInitialData(
                    filterData?.value?.map((status) => {
                        return status;
                    })
                );
            }
        });
    }, [initialData]);

    useEffect(() => {
        initialData?.forEach((filterData) => {
            if (filterData?.id === filterDropdownNames.API) {
                setAPIInitialData(
                    filterData?.value?.map((apiData) => {
                        return apiData;
                    })
                );
            }
        });
    }, [initialData]);

    const handleOnChangeDropdown = (val, type) => {
        setIsClearAllSelectedData(false);
        let filtersNew = [...filtersAll];

        if (filtersNew?.length > 0) {
            filtersNew = filtersNew.filter((f) => f.id !== type);
        }
        if (val.length > 0) {
            for (const value in filterDropdownNames) {
                if (type === filterDropdownNames[value]) {
                    filtersNew.push({
                        id: type,
                        value: val,
                    });
                }
            }
        }

        setFiltersAll(filtersNew);
    };

    useEffect(() => {
        setFiltersAll((prevFilters) => {
            let filtersNew = [...prevFilters];

            if (filtersNew?.length > 0) {
                filtersNew = filtersNew.filter((f) => f.id !== "ID");
            }

            return filtersNew;
        });
    }, []);

    useEffect(() => {
        let filtersNew = [...initialData];

        if (filtersNew?.length > 0) {
            filtersNew = filtersNew.filter((f) => f.id !== "ID");
        }
        setFiltersAll(filtersNew);
    }, [initialData]);

    const handleClick = () => {
        setFiltersData(filtersAll);
        setShow(false);
    };

    const handleClearAll = () => {
        setFiltersAll([]);
        setIsClearAllSelectedData(true);
    };

    return (
        <VStack spacing="Two">
                <Subject
                    subjectName="Filter"
                    showPhoto={false}
                    isMoreIcon={false}
                />

                {filtersAll?.length !== 0 && (
                    <VStack align="flex-end" spacing="Zero">
                        <TertiaryButton
                            label="Clear All"
                            leadingIcon="clear"
                            onClick={handleClearAll}
                        />
                    </VStack>
                )}

                <VStack>
                    <DropdownMultiSelect
                        isClearAllSelectedValue={
                            isClearAllSelectedData || !filtersAll?.length
                        }
                        initialData={clientInitialData}
                        itemsAreLoading={
                            clientsFilter.isLoading ||
                            clientDropdownOptions?.length === 0
                        }
                        optionsData={clientDropdownOptions}
                        onChangeDropdown={(val) =>
                            handleOnChangeDropdown(
                                val,
                                filterDropdownNames.client
                            )
                        }
                        isAccordion={true}
                        title="Client"
                        isSmallSize={true}
                        showCountWithLabel={false}
                    />

                    <DropdownMultiSelect
                        isClearAllSelectedValue={
                            isClearAllSelectedData || !filtersAll?.length
                        }
                        initialData={clientStatusInitialData}
                        optionsData={clientStatusOptions}
                        onChangeDropdown={(val) =>
                            handleOnChangeDropdown(
                                val,
                                filterDropdownNames.clientStatus
                            )
                        }
                        isAccordion={true}
                        title="Client Status"
                        isSmallSize={true}
                        showCountWithLabel={false}
                    />

                    <DropdownMultiSelect
                        isClearAllSelectedValue={
                            isClearAllSelectedData || !filtersAll?.length
                        }
                        initialData={APIInitialData}
                        optionsData={apiStatusOptions}
                        onChangeDropdown={(val) =>
                            handleOnChangeDropdown(val, filterDropdownNames.API)
                        }
                        isAccordion={true}
                        title="Extraction Status"
                        isSmallSize={true}
                        showCountWithLabel={false}
                    />
                </VStack>
                <DrawerActions
                    primaryAction={{
                        label: "Apply",
                        onClick: () => handleClick(),
                    }}
                />
            </VStack>
    );
};

FilterDrawer.propTypes = {
    setFiltersData: PropTypes.func.isRequired,
    initialData: PropTypes.array
};

export default React.memo(FilterDrawer);
